import Multiselect from "multiselect-react-dropdown";
import React, { useContext, useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
import ReactQuill from "react-quill";
import { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css"; // Quill's styles
import AddNewEmail from "../ProjectDetails/addNewEmail";

export default function ProjectDetailsTab({
  setActiveTab,
  data,
  setData,
  projCategory,
  owners,
  setOwners,
  companies,
  setCompanies,
  projEditing,
  profileTypeSelected,
  setProfileTypeSelected,
  proposalType,
  setProposalType,
}) {
  const { API_URL } = useContext(UrlContext);
  const [showInvalidEmail, setShowInvalidEmail] = useState(false);
  const [leadEmailErrorMsg, setLeadEmailErrorMsg] = useState("");
  const [showInvalidProjectName, setShowInvalidProjectName] = useState(false);
  const [projNameErrorMsg, setProjNameErrorMsg] = useState("");
  const [showDescLengthError, setShowDescLengthError] = useState(false);
  const [emailClassName, setEmailClassName] = useState("");
  const [projectNameClassName, setProjectNameClassName] = useState("");
  const [clientOwnerClassName, setClientOwnerClassName] = useState("");
  const [invalidClientOwner, setInvalidClientOwner] = useState(false);
  const [clientOwnerErrorMsg, setClientOwnerErrorMsg] = useState("");
  // const [initializePopup, setInitializePopup] = useState(false)
  const [emailLoading, setEmailLoading] = useState(false);
  const [profileTypeClassName, setProfileTypeClassName] = useState("");
  const [showInvalidProfileType, setShowInvalidProfileType] = useState(false);
  const [additionalEmails, setAdditionalEmails] = useState([]);
  const [showAdditionalEmails, setShowAdditionalEmails] = useState(false);
  const [companyUsed, setCompanyUsed] = useState("");
  const [companyFound, setCompanyFound] = useState("");
  const [companyClassName, setCompanyClassName] = useState("");
  const [showInvalidCompany, setShowInvalidCompany] = useState(false);
  const [companyErrorMsg, setCompanyErrorMsg] = useState("");
  const [isLead, setIsLead] = useState(false);

  const industyPreferenceList = [
    "Agriculture, Foresty & Paper",
    "Automotive Industry",
    "Aviation & Aerospace",
    "Chemicals",
    "Construction Industry",
    "Consumer Goods",
    "Energy and Utilities",
    "Financial Services",
    "Food & Beverage Industry",
    "Healthcare",
    "Pharma & Biotech",
    "Industrial Goods & Machinery",
    "Insurance",
    "Travel & Tourism",
    "Media & Entertainment",
    "Medical Technology",
    "Metals & Mining",
    "Oil & Gas Industry",
    "Private Equity",
    "Professional Service Firms",
    "Public Sector",
    "Real Estate",
    "Retail Industry",
    "Shipbuilding",
    "Software & IT Services",
    "Telecommunication",
    "Transport & Logistic",
    "Water & Waste",
  ];

  const handleDescriptionChange = (content) => {
    setData({ ...data, projectDescription: content });

    // Check length of the content (removing HTML tags if needed)
    const textLength = content.replace(/<[^>]*>/g, "").length;

    if (textLength > 1800) {
      setShowDescLengthError(true);
    } else {
      setShowDescLengthError(false);
    }
  };

  const markdownToHtml = (md) => {
    if (!md) return "";
    let input = md.replace(/\r\n/g, "\n");

    // Extract fenced code blocks first and replace with placeholders
    const codeBlocks = [];
    input = input.replace(/```([\s\S]*?)```/g, (m, p1) => {
      const idx = codeBlocks.length;
      codeBlocks.push(p1);
      return `%%CODEBLOCK_${idx}%%`;
    });

    // Inline code
    input = input.replace(/`([^`]+)`/g, (m, p1) => `<code>${p1.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</code>`);

    // Headings
    input = input
      .replace(/^######\s+(.*)$/gm, '<h6>$1</h6>')
      .replace(/^#####\s+(.*)$/gm, '<h5>$1</h5>')
      .replace(/^####\s+(.*)$/gm, '<h4>$1</h4>')
      .replace(/^###\s+(.*)$/gm, '<h3>$1</h3>')
      .replace(/^##\s+(.*)$/gm, '<h2>$1</h2>')
      .replace(/^#\s+(.*)$/gm, '<h1>$1</h1>');

    // Bold then Italic
    input = input.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    input = input.replace(/(^|[^*])\*(?!\s)(.*?)(?!\s)\*(?!\*)/g, '$1<em>$2</em>');

    // Links [text](url)
    input = input.replace(/\[([^\]]+)\]\(([^\s)]+)(?:\s+\"[^\"]*\")?\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

    // Lists and paragraphs
    const lines = input.split('\n');
    let html = '';
    let inUl = false;
    let inOl = false;
    const closeLists = () => {
      if (inUl) { html += '</ul>'; inUl = false; }
      if (inOl) { html += '</ol>'; inOl = false; }
    };
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      if (/^\s*-\s+/.test(line) || /^\s*\*\s+/.test(line)) {
        if (!inUl) { closeLists(); html += '<ul>'; inUl = true; }
        html += `<li>${line.replace(/^\s*[-*]\s+/, '')}</li>`;
        continue;
      }
      const olMatch = line.match(/^\s*(\d+)\.\s+/);
      if (olMatch) {
        if (!inOl) { closeLists(); html += '<ol>'; inOl = true; }
        html += `<li>${line.replace(/^\s*\d+\.\s+/, '')}</li>`;
        continue;
      }
      if (line.trim() === '') {
        // paragraph break
        closeLists();
        html += '<p><br/></p>';
      } else if (/^<h[1-6]>/.test(line)) {
        closeLists();
        html += line;
      } else {
        closeLists();
        html += `<p>${line}</p>`;
      }
    }
    closeLists();

    // Restore code blocks
    html = html.replace(/%%CODEBLOCK_(\d+)%%/g, (m, idx) => {
      const content = codeBlocks[Number(idx)] || '';
      const escaped = content.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return `<pre><code>${escaped}</code></pre>`;
    });

    return html;
  };

  const handleMagicWandClick = async () => {
    const currentText = data.projectDescription || "";
    if (currentText.replace(/<[^>]*>?/gm, '').trim() === "") return;

    try {
      Swal.fire({
        title: 'Generating description...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      const res = await fetch(`https://ai.expertpowerhouse.com/expert-search/generate-project-description`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ text: currentText }),
      });

      const json = await res.json();
      if (res.ok && json.status === "success") {
        setData({ ...data, projectDescription: json.description });
        Swal.close();
      } else {
        Swal.fire({
          title: "Error!",
          text: json.message || "Failed to generate project description",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    if (data.additionalEmails.length > 0) {
      setAdditionalEmails(data.additionalEmails);
      setShowAdditionalEmails(true);
    }
  }, [data]);

  // const modules = {
  //   toolbar: [
  //     [{ header: '1' }, { header: '2' }, { font: [] }],
  //     [{ list: 'ordered' }, { list: 'bullet' }],
  //     ['bold', 'italic', 'underline', 'strike', 'blockquote'],
  //     [{ align: [] }],
  //     [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  //     ['link', 'image'],
  //     ['clean'], // remove formatting button
  //   ],
  // };

  // const formats = [
  //   'header', 'font', 'list', 'bullet', 'bold', 'italic', 'underline',
  //   'strike', 'blockquote', 'align', 'color', 'background', 'link', 'image'
  // ];

  const handleAddingAdditionalEmails = (attendees) => {
    setAdditionalEmails(attendees);
    setData({ ...data, additionalEmails: attendees });
  };

  const handleCompanyChange = (selectedOption) => {
    if (selectedOption) {
      setCompanyFound(selectedOption);
      setData((prevData) => ({ ...prevData, company: selectedOption.value }));
      setCompanyClassName("");
      setShowInvalidCompany(false);
    } else {
      setCompanyFound("");
    }
  };

  const Font = Quill.import("formats/font");
  Font.whitelist = [
    "arial",
    "georgia",
    "times-new-roman",
    "courier-new",
    "verdana",
    "tahoma",
    "lucida",
  ];
  Quill.register(Font, true);

  return (
    <fieldset>
      <div className="form-card">
        <div className="flex-center position-relative mb-1">
          {emailLoading && (
            <img
              className="return-msg-icon"
              style={{ top: "13px", left: "160px" }}
              src={LoadingIcon}
              alt=""
            />
          )}
          <label className="fieldlabels">Lead Email*</label>
          <input
            type="email"
            name="leademail"
            autoComplete="on"
            disabled={projEditing}
            className={emailClassName}
            placeholder="Lead Email"
            onChange={(e) => {
              setData({ ...data, leadEmail: e.target.value });
              if (emailClassName !== "") {
                const regEx = /\S+@\S+\.\S+/;
                if (regEx.test(e.target.value)) {
                  setEmailClassName("");
                  setShowInvalidEmail(false);
                } else {
                  setShowInvalidEmail(true);
                  setLeadEmailErrorMsg("Please enter a valid email address");
                }
              }
            }}
            onBlur={(e) => {
              if (!e.target.value) {
                setEmailClassName("border border-danger");
                setShowInvalidEmail(true);
                setLeadEmailErrorMsg("Lead email is required");
                return;
              }
              if (
                emailClassName === "" ||
                emailClassName === "border border-danger"
              ) {
                const regEx = /\S+@\S+\.\S+/;
                if (!regEx.test(e.target.value)) {
                  setShowInvalidEmail(true);
                  setEmailClassName("border border-danger");
                  setLeadEmailErrorMsg("Please enter a valid email address");
                  return;
                }
              }

              // setInitializePopup(true)
              setEmailLoading(true);
              setShowInvalidEmail(false);
              const url = `${API_URL}check-zoho`;
              const ephToken = localStorage.getItem("eph-token");
              const token = JSON.parse(ephToken).value;

              fetch(url, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "x-access-token": token,
                },
                body: JSON.stringify({ leadEmail: data.leadEmail }),
              })
                .then((res) => res.json())
                .then((data) => {
                  setEmailLoading(false);
                  // console.log(data)
                  // setInitializePopup(false)
                  setIsLead(data.isLead);

                  if (data.owners) {
                    const defaultOwner = data.owners?.find(
                      (owner) => owner.default
                    );
                    if (defaultOwner) {
                      setData((prevData) => ({
                        ...prevData,
                        clientOwner: defaultOwner.fullname,
                      }));
                    }
                    setOwners(data.owners);
                  } else if (data.message) {
                    // Swal.fire({
                    //     title: 'Error!',
                    //     text: data.message,
                    //     icon: 'error',
                    //     confirmButtonText: 'OK'
                    // })
                    setEmailClassName("border border-danger");
                    setShowInvalidEmail(true);
                    setLeadEmailErrorMsg(data.message);
                  } else {
                    Swal.fire({
                      title: "Error!",
                      text: "Something went wrong",
                      icon: "error",
                      confirmButtonText: "OK",
                    });
                  }

                  if (data.isLead) {
                    setCompanyUsed(data.companyFromCRM);
                    if (
                      Array.isArray(data.companies) &&
                      data.companies.length > 0
                    ) {
                      if (data.companyFromCRM) {
                        const existingOption = data.companies?.find(
                          (opt) =>
                            opt.label.toLowerCase() ===
                            data.companyFromCRM.toLowerCase()
                        );
                        if (existingOption) {
                          setCompanyFound(existingOption);
                          setData((prevData) => ({
                            ...prevData,
                            company: existingOption.value,
                          }));
                        } else {
                          setData((prevData) => ({ ...prevData, company: "" }));
                        }
                      } else {
                        setData((prevData) => ({ ...prevData, company: "" }));
                      }
                      setCompanies(data.companies);
                    }
                    // else if (typeof data.companies === 'string') {
                    //   setCompanyUsed(data.companies)
                    //   setData((prevData) => ({ ...prevData, company: data.companies }));
                    // }
                    // else {
                    //   setCompanyUsed('')
                    // }
                  }
                });
            }}
            value={data.leadEmail}
          />
          <i
            className={`fa-solid ${
              showAdditionalEmails ? "fa-minus-circle" : "fa-circle-plus"
            }`}
            style={{
              marginTop: "10px",
              marginLeft: "10px",
              fontSize: "20px",
              color: "grey",
              cursor: "pointer",
            }}
            onClick={() => {
              if (showAdditionalEmails) {
                setShowAdditionalEmails(false);
                setAdditionalEmails([]);
              } else {
                setShowAdditionalEmails(true);
              }
            }}
          ></i>
          {showInvalidEmail && (
            <span className="invalid-text-sign">{leadEmailErrorMsg}</span>
          )}
        </div>
        <div className="flex-center position-relative mb-1">
          {showAdditionalEmails && (
            <>
              <label className="fieldlabels">Additional Emails</label>
              <AddNewEmail
                handleInputChange={handleAddingAdditionalEmails}
                currentEmails={additionalEmails}
              />
            </>
          )}
        </div>
        <div className="flex-center position-relative mb-1">
          <label className="fieldlabels">Client Owner*</label>
          <select
            className={`form-control ${clientOwnerClassName}`}
            onChange={(e) => {
              setData({ ...data, clientOwner: e.target.value });
              if (e.target.value) {
                setInvalidClientOwner(false);
                setClientOwnerClassName("");
              }
            }}
            value={data.clientOwner}
          >
            <option value="">Select client owner</option>
            {owners?.map((owner) => (
              <option key={owner.fullname} value={owner.fullname}>
                {owner.username}
              </option>
            ))}
          </select>
          {invalidClientOwner && (
            <span className="invalid-text-sign">{clientOwnerErrorMsg}</span>
          )}
        </div>
        <div className="flex-center position-relative mb-1">
          {isLead && (
            <>
              <label className="fieldlabels">Company from CRM</label>
              <input
                type="text"
                style={{ width: "50%" }}
                className="companyNameFromCRM"
                value={companyUsed ? companyUsed : ""}
                disabled
              ></input>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "50%",
                }}
              >
                <CreatableSelect
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: "96%",
                      marginTop: "3px",
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "200px", // Set maximum height
                      overflowY: "auto", // Enable scrolling if options exceed height
                    }),
                    control: (base) => ({
                      ...base,
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "5px",
                    }),
                    input: (base) => ({
                      ...base,
                      minWidth: "100px",
                      width: "100%",
                      overflow: "hidden",
                      whiteSpace: "wrap",
                      textOverflow: "ellipsis",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      overflow: "visible", // Ensures full visibility
                      maxWidth: "100%",
                    }),
                  }}
                  className={`ml-3 ${companyClassName}`}
                  menuPlacement="top"
                  options={companies}
                  value={companyFound}
                  onChange={handleCompanyChange}
                  // onCreateOption={handleCreate} // Enables creating new options
                  placeholder="Select/Create a company"
                  isClearable
                />
                {showInvalidCompany && (
                  <span
                    className="invalid-text-sign"
                    style={{ marginLeft: "415px" }}
                  >
                    {companyErrorMsg}
                  </span>
                )}
              </div>
            </>
          )}
        </div>
        <div className="flex-center position-relative mb-1">
          <label className="fieldlabels">Project Name*</label>
          <input
            type="text"
            className={projectNameClassName}
            placeholder="New project name"
            onChange={(e) => {
              const regex = /[!@#$%^*()+=\[\]\\';,./{}|\\":<>?_]/g;
              if (regex.test(e.target.value)) {
                setShowInvalidProjectName(true);
                setProjNameErrorMsg(
                  "Project name should not have special characters [!@#$%^*()+=';,./{}|\":<>?_]"
                );
                setProjectNameClassName("invalid-project-name");
              } else {
                setShowInvalidProjectName(false);
                setProjectNameClassName("");
              }
              if (e.target.value.length > 50) {
                setShowInvalidProjectName(true);
                setProjNameErrorMsg(
                  "Project name should be less than 50 characters."
                );
                setProjectNameClassName("invalid-project-name");
              } else {
                setShowInvalidProjectName(false);
                setProjectNameClassName("");
              }
              setData({ ...data, projectName: e.target.value });
              if (projectNameClassName !== "") {
                if (e.target.value.length > 0) {
                  setProjectNameClassName("");
                }
              }
            }}
            value={data.projectName}
          />
          {showInvalidProjectName && (
            <span className="invalid-text-sign">{projNameErrorMsg}</span>
          )}
          <span className="des-count-span">{data.projectName.length} / 50</span>
        </div>
        <div className="flex-center position-relative mb-1">
          <label className="fieldlabels" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            Project Description
            <i
              className="fa-solid fa-wand-magic-sparkles"
              title="AI assistant"
              style={{ cursor: "pointer", color: "#6b7280", fontSize: "14px" }}
              onClick={handleMagicWandClick}
            ></i>
          </label>
          {/* Using ReactQuill to handle rich text input */}
          {/* <div className="editor-wrapper">
            <ReactQuill
              theme="snow"
              value={data.projectDescription} // Controlled component value
              onChange={handleDescriptionChange} // Handle input change
              modules={{
                toolbar: [
                  [{ header: [1, 2, false] }],
                  ["bold", "italic", "underline", "strike"],
                  [{ list: "ordered" }, { list: "bullet" }],
                ],
              }}
              formats={[
                "header",
                "bold",
                "italic",
                "underline",
                "strike",
                "list",
                "bullet",
              ]}
              // placeholder="Project description"
            />
          </div> */}

          <div className={'flex-wrap border rounded w-full mb-3 border-grey-50'}>
            <ReactQuill
              theme="snow"
              value={data.projectDescription}
              onChange={handleDescriptionChange}
              modules={{
                toolbar: [
                  [{ font: Font.whitelist }],
                  [{ header: [1, 2, false] }],
                  ["bold", "italic", "underline", "strike"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["link"]
                ],
              }}
              formats={["font", "header", "bold", "italic", "underline", "strike", "list", "bullet", "link"]}
              style={{ overflowY: "auto", display: "flex", flexDirection: "column" }}
            />
          <style>
            {`
              // .ql-editor {
              //   min-height: 100px;
              //   padding: 5px !important;
              //   font-size: 14px !important;
              //   font-family: Verdana, sans-serif;
              // }
              .ql-editor {
                font-family: Arial, sans-serif;
                font-size: 14px;
                line-height: 1.4;
                padding: 5px !important;
              }
              .ql-container {
                height: auto !important;
                min-height: 100px;
                padding-bottom: 10px;
              }
              .ql-container .ql-snow .ql-hidden {
                display: none !important;
              }
              .ql-toolbar.ql-snow {
                position: inherit;
                top: 0;
                right: 24px;
                padding: 3px;
                display: flex;
                flex-wrap: nowrap;
                gap: 10px;
              }
              .ql-font-arial { font-family: Arial, sans-serif; }
              .ql-font-georgia { font-family: Georgia, serif; }
              .ql-font-times-new-roman { font-family: "Times New Roman", serif; }
              .ql-font-courier-new { font-family: "Courier New", monospace; }
              .ql-font-verdana { font-family: Verdana, sans-serif; }
              .ql-font-tahoma { font-family: Tahoma, sans-serif; }
              .ql-font-lucida { font-family: "Lucida Sans Unicode", sans-serif; }
              .ql-font-roboto { font-family: "Roboto", sans-serif; }
              .ql-font-lato { font-family: "Lato", sans-serif; }
          
              /* Dropdown font preview fix */
              .ql-snow .ql-picker.ql-font .ql-picker-label::before,
              .ql-snow .ql-picker.ql-font .ql-picker-item::before {
                content: attr(data-value);
                font-family: inherit;
              }
          
              .ql-picker-item[data-value="arial"]::before,
              .ql-picker-label[data-value="arial"]::before {
                font-family: Arial, sans-serif;
                content: "Arial";
              }
          
              .ql-picker-item[data-value="georgia"]::before,
              .ql-picker-label[data-value="georgia"]::before {
                font-family: Georgia, serif;
                content: "Georgia";
              }
          
              .ql-picker-item[data-value="times-new-roman"]::before,
              .ql-picker-label[data-value="times-new-roman"]::before {
                font-family: "Times New Roman", serif;
                content: "Times New Roman";
              }
          
              .ql-picker-item[data-value="courier-new"]::before,
              .ql-picker-label[data-value="courier-new"]::before {
                font-family: "Courier New", monospace;
                content: "Courier New";
              }
          
              .ql-picker-item[data-value="verdana"]::before,
              .ql-picker-label[data-value="verdana"]::before {
                font-family: Verdana, sans-serif;
                content: "Verdana";
              }
          
              .ql-picker-item[data-value="tahoma"]::before,
              .ql-picker-label[data-value="tahoma"]::before {
                font-family: Tahoma, sans-serif;
                content: "Tahoma";
              }
          
              .ql-picker-item[data-value="lucida"]::before,
              .ql-picker-label[data-value="lucida"]::before {
                font-family: "Lucida Sans Unicode", sans-serif;
                content: "Lucida";
              }
          
              // .ql-editor div {
              //   margin-bottom: 4px; /* matches Gmail spacing */
              //   line-height: 1.4;
              // }
          
              .ql-editor ul {
                padding-left: 1.25em;
                margin: 0.5em 0;
              }
            `}
          </style>
          </div>

          {/* <span className="des-count-span">
            {data.projectDescription.length} / 1800
          </span>
          {data.projectDescription.length > 1800 && (
            <span className="invalid-text-sign">
              Maximum length 1800 characters only!
            </span>
          )} */}
        </div>

        <div className="flex-center mb-1">
          <label className="fieldlabels">Profile Type</label>
          <div className="w-100" style={{ width: "1000px" }}>
            <select
              className={`form-control ${profileTypeClassName}`}
              onChange={(e) => {
                if (e.target.value) {
                  setData({ ...data, projectConsultantType: e.target.value });
                  setProfileTypeSelected(true);
                  setProfileTypeClassName("");
                  setShowInvalidProfileType(false);
                } else {
                  setProfileTypeSelected(false);
                  setProfileTypeClassName("");
                }
              }}
              value={data.projectConsultantType}
            >
              <option value="">Select profile type</option>
              <option value="exp">Experts (Expert call)</option>
              <option value="con">
                Consultants (Long-term project support)
              </option>
              <option value="int">
                Interim (Long-term management support)
              </option>
            </select>
            {showInvalidProfileType && (
              <span className="invalid-text-sign-profileType">
                Profile type required
              </span>
            )}
          </div>
          <div className="w-100">
            <>
              <div class="custom-control custom-control-right custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch-for-proposal"
                  checked={proposalType}
                  onChange={(e) => {
                    setProposalType(e.target.checked);
                    setData({ ...data, proposal: e.target.checked });
                  }}
                />
                <label
                  class="custom-control-label fieldlabels"
                  for="customSwitch-for-proposal"
                  style={{ marginLeft: "10px" }}
                >
                  Proposal Stage
                </label>
                {!data.proposal ? (
                  <label
                    class="makePublicLabel"
                    style={{ marginLeft: "60px", fontWeight: "bold" }}
                  >
                    NO!
                  </label>
                ) : (
                  <label
                    class="makePublicLabel"
                    style={{ marginLeft: "60px", fontWeight: "bold" }}
                  >
                    YES!{" "}
                  </label>
                )}
              </div>
            </>
            {/* <label for="proposalType" className="fieldlabels" style={{marginLeft: '10px'}}>Proposal</label>
                  <input 
                    type="checkbox" 
                    id="proposalType" 
                    name="proposalType" 
                    checked={proposalType} 
                    onChange={(e) => {
                      setProposalType(e.target.checked)
                      setData({...data, proposal: e.target.checked})
                    }}
                    /> */}
          </div>
        </div>
        <div className="flex-center mb-1">
          <label className="fieldlabels">Location</label>
          <select
            className="form-control"
            onChange={(e) =>
              setData({ ...data, projectRegion: e.target.value })
            }
            value={data.projectRegion}
          >
            <option value="">Select region</option>
            <option value="Europe">Europe</option>
            <option value="Middle East">Middle East</option>
            <option value="Asia Pacific">Asia Pacific</option>
            <option value="Africa">Africa</option>
            <option value="Latin America">Latin America</option>
            <option value="North America">North America</option>
            <option value="Global">Global</option>
          </select>

          <select
            className="form-control ml-3 selectpicker"
            onChange={(e) =>
              setData({ ...data, projectLocation: e.target.value })
            }
            value={data.projectLocation}
          >
            <option value="">Select country</option>
            <option value="Afghanistan">Afghanistan</option>
            <option value="Åland Islands">Åland Islands</option>
            <option value="Albania">Albania</option>
            <option value="Algeria">Algeria</option>
            <option value="American Samoa">American Samoa</option>
            <option value="Andorra">Andorra</option>
            <option value="Angola">Angola</option>
            <option value="Anguilla">Anguilla</option>
            <option value="Antarctica">Antarctica</option>
            <option value="Antigua and Barbuda">Antigua and Barbuda</option>
            <option value="Argentina">Argentina</option>
            <option value="Armenia">Armenia</option>
            <option value="Aruba">Aruba</option>
            <option value="Australia">Australia</option>
            <option value="Austria">Austria</option>
            <option value="Azerbaijan">Azerbaijan</option>
            <option value="Bahamas">Bahamas</option>
            <option value="Bahrain">Bahrain</option>
            <option value="Bangladesh">Bangladesh</option>
            <option value="Barbados">Barbados</option>
            <option value="Belarus">Belarus</option>
            <option value="Belgium">Belgium</option>
            <option value="Belize">Belize</option>
            <option value="Benin">Benin</option>
            <option value="Bermuda">Bermuda</option>
            <option value="Bhutan">Bhutan</option>
            <option value="Bolivia">Bolivia</option>
            <option value="Bosnia and Herzegovina">
              Bosnia and Herzegovina
            </option>
            <option value="Botswana">Botswana</option>
            <option value="Bouvet Island">Bouvet Island</option>
            <option value="Brazil">Brazil</option>
            <option value="British Indian Ocean Territory">
              British Indian Ocean Territory
            </option>
            <option value="Brunei Darussalam">Brunei Darussalam</option>
            <option value="Bulgaria">Bulgaria</option>
            <option value="Burkina Faso">Burkina Faso</option>
            <option value="Burundi">Burundi</option>
            <option value="Cambodia">Cambodia</option>
            <option value="Cameroon">Cameroon</option>
            <option value="Canada">Canada</option>
            <option value="Cape Verde">Cape Verde</option>
            <option value="Cayman Islands">Cayman Islands</option>
            <option value="Central African Republic">
              Central African Republic
            </option>
            <option value="Chad">Chad</option>
            <option value="Chile">Chile</option>
            <option value="China">China</option>
            <option value="Christmas Island">Christmas Island</option>
            <option value="Cocos (Keeling) Islands">
              Cocos (Keeling) Islands
            </option>
            <option value="Colombia">Colombia</option>
            <option value="Comoros">Comoros</option>
            <option value="Congo">Congo</option>
            <option value="Congo, The Democratic Republic of The">
              Congo, The Democratic Republic of The
            </option>
            <option value="Cook Islands">Cook Islands</option>
            <option value="Costa Rica">Costa Rica</option>
            <option value="Cote D'ivoire">Cote D'ivoire</option>
            <option value="Croatia">Croatia</option>
            <option value="Cuba">Cuba</option>
            <option value="Cyprus">Cyprus</option>
            <option value="Czech Republic">Czech Republic</option>
            <option value="Denmark">Denmark</option>
            <option value="Djibouti">Djibouti</option>
            <option value="Dominica">Dominica</option>
            <option value="Dominican Republic">Dominican Republic</option>
            <option value="Ecuador">Ecuador</option>
            <option value="Egypt">Egypt</option>
            <option value="El Salvador">El Salvador</option>
            <option value="Equatorial Guinea">Equatorial Guinea</option>
            <option value="Eritrea">Eritrea</option>
            <option value="Estonia">Estonia</option>
            <option value="Ethiopia">Ethiopia</option>
            <option value="Falkland Islands (Malvinas)">
              Falkland Islands (Malvinas)
            </option>
            <option value="Faroe Islands">Faroe Islands</option>
            <option value="Fiji">Fiji</option>
            <option value="Finland">Finland</option>
            <option value="France">France</option>
            <option value="French Guiana">French Guiana</option>
            <option value="French Polynesia">French Polynesia</option>
            <option value="French Southern Territories">
              French Southern Territories
            </option>
            <option value="Gabon">Gabon</option>
            <option value="Gambia">Gambia</option>
            <option value="Georgia">Georgia</option>
            <option value="Germany">Germany</option>
            <option value="Ghana">Ghana</option>
            <option value="Gibraltar">Gibraltar</option>
            <option value="Greece">Greece</option>
            <option value="Greenland">Greenland</option>
            <option value="Grenada">Grenada</option>
            <option value="Guadeloupe">Guadeloupe</option>
            <option value="Guam">Guam</option>
            <option value="Guatemala">Guatemala</option>
            <option value="Guernsey">Guernsey</option>
            <option value="Guinea">Guinea</option>
            <option value="Guinea-bissau">Guinea-bissau</option>
            <option value="Guyana">Guyana</option>
            <option value="Haiti">Haiti</option>
            <option value="Heard Island and Mcdonald Islands">
              Heard Island and Mcdonald Islands
            </option>
            <option value="Holy See (Vatican City State)">
              Holy See (Vatican City State)
            </option>
            <option value="Honduras">Honduras</option>
            <option value="Hong Kong">Hong Kong</option>
            <option value="Hungary">Hungary</option>
            <option value="Iceland">Iceland</option>
            <option value="India">India</option>
            <option value="Indonesia">Indonesia</option>
            <option value="Iran, Islamic Republic of">
              Iran, Islamic Republic of
            </option>
            <option value="Iraq">Iraq</option>
            <option value="Ireland">Ireland</option>
            <option value="Isle of Man">Isle of Man</option>
            <option value="Israel">Israel</option>
            <option value="Italy">Italy</option>
            <option value="Jamaica">Jamaica</option>
            <option value="Japan">Japan</option>
            <option value="Jersey">Jersey</option>
            <option value="Jordan">Jordan</option>
            <option value="Kazakhstan">Kazakhstan</option>
            <option value="Kenya">Kenya</option>
            <option value="Kiribati">Kiribati</option>
            <option value="Korea, Democratic People's Republic of">
              Korea, Democratic People's Republic of
            </option>
            <option value="Korea, Republic of">Korea, Republic of</option>
            <option value="Kuwait">Kuwait</option>
            <option value="Kyrgyzstan">Kyrgyzstan</option>
            <option value="Lao People's Democratic Republic">
              Lao People's Democratic Republic
            </option>
            <option value="Latvia">Latvia</option>
            <option value="Lebanon">Lebanon</option>
            <option value="Lesotho">Lesotho</option>
            <option value="Liberia">Liberia</option>
            <option value="Libyan Arab Jamahiriya">
              Libyan Arab Jamahiriya
            </option>
            <option value="Liechtenstein">Liechtenstein</option>
            <option value="Lithuania">Lithuania</option>
            <option value="Luxembourg">Luxembourg</option>
            <option value="Macao">Macao</option>
            <option value="Macedonia, The Former Yugoslav Republic of">
              Macedonia, The Former Yugoslav Republic of
            </option>
            <option value="Madagascar">Madagascar</option>
            <option value="Malawi">Malawi</option>
            <option value="Malaysia">Malaysia</option>
            <option value="Maldives">Maldives</option>
            <option value="Mali">Mali</option>
            <option value="Malta">Malta</option>
            <option value="Marshall Islands">Marshall Islands</option>
            <option value="Martinique">Martinique</option>
            <option value="Mauritania">Mauritania</option>
            <option value="Mauritius">Mauritius</option>
            <option value="Mayotte">Mayotte</option>
            <option value="Mexico">Mexico</option>
            <option value="Micronesia, Federated States of">
              Micronesia, Federated States of
            </option>
            <option value="Moldova, Republic of">Moldova, Republic of</option>
            <option value="Monaco">Monaco</option>
            <option value="Mongolia">Mongolia</option>
            <option value="Montenegro">Montenegro</option>
            <option value="Montserrat">Montserrat</option>
            <option value="Morocco">Morocco</option>
            <option value="Mozambique">Mozambique</option>
            <option value="Myanmar">Myanmar</option>
            <option value="Namibia">Namibia</option>
            <option value="Nauru">Nauru</option>
            <option value="Nepal">Nepal</option>
            <option value="Netherlands">Netherlands</option>
            <option value="Netherlands Antilles">Netherlands Antilles</option>
            <option value="New Caledonia">New Caledonia</option>
            <option value="New Zealand">New Zealand</option>
            <option value="Nicaragua">Nicaragua</option>
            <option value="Niger">Niger</option>
            <option value="Nigeria">Nigeria</option>
            <option value="Niue">Niue</option>
            <option value="Norfolk Island">Norfolk Island</option>
            <option value="Northern Mariana Islands">
              Northern Mariana Islands
            </option>
            <option value="Norway">Norway</option>
            <option value="Oman">Oman</option>
            <option value="Pakistan">Pakistan</option>
            <option value="Palau">Palau</option>
            <option value="Palestinian Territory, Occupied">
              Palestinian Territory, Occupied
            </option>
            <option value="Panama">Panama</option>
            <option value="Papua New Guinea">Papua New Guinea</option>
            <option value="Paraguay">Paraguay</option>
            <option value="Peru">Peru</option>
            <option value="Philippines">Philippines</option>
            <option value="Pitcairn">Pitcairn</option>
            <option value="Poland">Poland</option>
            <option value="Portugal">Portugal</option>
            <option value="Puerto Rico">Puerto Rico</option>
            <option value="Qatar">Qatar</option>
            <option value="Reunion">Reunion</option>
            <option value="Romania">Romania</option>
            <option value="Russian Federation">Russian Federation</option>
            <option value="Rwanda">Rwanda</option>
            <option value="Saint Helena">Saint Helena</option>
            <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
            <option value="Saint Lucia">Saint Lucia</option>
            <option value="Saint Pierre and Miquelon">
              Saint Pierre and Miquelon
            </option>
            <option value="Saint Vincent and The Grenadines">
              Saint Vincent and The Grenadines
            </option>
            <option value="Samoa">Samoa</option>
            <option value="San Marino">San Marino</option>
            <option value="Sao Tome and Principe">Sao Tome and Principe</option>
            <option value="Saudi Arabia">Saudi Arabia</option>
            <option value="Senegal">Senegal</option>
            <option value="Serbia">Serbia</option>
            <option value="Seychelles">Seychelles</option>
            <option value="Sierra Leone">Sierra Leone</option>
            <option value="Singapore">Singapore</option>
            <option value="Slovakia">Slovakia</option>
            <option value="Slovenia">Slovenia</option>
            <option value="Solomon Islands">Solomon Islands</option>
            <option value="Somalia">Somalia</option>
            <option value="South Africa">South Africa</option>
            <option value="South Georgia and The South Sandwich Islands">
              South Georgia and The South Sandwich Islands
            </option>
            <option value="Spain">Spain</option>
            <option value="Sri Lanka">Sri Lanka</option>
            <option value="Sudan">Sudan</option>
            <option value="Suriname">Suriname</option>
            <option value="Svalbard and Jan Mayen">
              Svalbard and Jan Mayen
            </option>
            <option value="Swaziland">Swaziland</option>
            <option value="Sweden">Sweden</option>
            <option value="Switzerland">Switzerland</option>
            <option value="Syrian Arab Republic">Syrian Arab Republic</option>
            <option value="Taiwan, Province of China">
              Taiwan, Province of China
            </option>
            <option value="Tajikistan">Tajikistan</option>
            <option value="Tanzania, United Republic of">
              Tanzania, United Republic of
            </option>
            <option value="Thailand">Thailand</option>
            <option value="Timor-leste">Timor-leste</option>
            <option value="Togo">Togo</option>
            <option value="Tokelau">Tokelau</option>
            <option value="Tonga">Tonga</option>
            <option value="Trinidad and Tobago">Trinidad and Tobago</option>
            <option value="Tunisia">Tunisia</option>
            <option value="Turkey">Turkey</option>
            <option value="Turkmenistan">Turkmenistan</option>
            <option value="Turks and Caicos Islands">
              Turks and Caicos Islands
            </option>
            <option value="Tuvalu">Tuvalu</option>
            <option value="Uganda">Uganda</option>
            <option value="Ukraine">Ukraine</option>
            <option value="United Arab Emirates">United Arab Emirates</option>
            <option value="United Kingdom">United Kingdom</option>
            <option value="United States">United States</option>
            <option value="United States Minor Outlying Islands">
              United States Minor Outlying Islands
            </option>
            <option value="Uruguay">Uruguay</option>
            <option value="Uzbekistan">Uzbekistan</option>
            <option value="Vanuatu">Vanuatu</option>
            <option value="Venezuela">Venezuela</option>
            <option value="Viet Nam">Viet Nam</option>
            <option value="Virgin Islands, British">
              Virgin Islands, British
            </option>
            <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
            <option value="Wallis and Futuna">Wallis and Futuna</option>
            <option value="Western Sahara">Western Sahara</option>
            <option value="Yemen">Yemen</option>
            <option value="Zambia">Zambia</option>
            <option value="Zimbabwe">Zimbabwe</option>
          </select>
        </div>
        <div className="flex-center mb-1">
          <label className="fieldlabels">Industy Preference</label>
          <div className="d-flex" style={{ width: "100%" }}>
            <select
              className="form-control mr-3"
              onChange={(e) =>
                setData({ ...data, projectIndustyPreference: e.target.value })
              }
              value={data.projectIndustyPreference}
              style={{ width: "25%" }}
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            {data.projectIndustyPreference === "Yes" &&
              !Array.isArray(data.projectIndustyPreferenceList) && (
                <div style={{ width: "100%" }} className="industry-div">
                  <select
                    className="form-control mr-3"
                    onChange={(e) => {
                      console.log(e.target.value);
                      setData({
                        ...data,
                        projectIndustyPreferenceList: e.target.value,
                      });
                    }}
                    value={data.projectIndustyPreferenceList}
                    // style={{ width: "25%" }}
                  >
                    <option value="">Select Industry</option>
                    {industyPreferenceList?.map((ind) => (
                      <option key={ind} value={ind}>
                        {ind}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            {data.projectIndustyPreference === "Yes" &&
              Array.isArray(data.projectIndustyPreferenceList) && (
                <div style={{ width: "100%" }} className="industry-div">
                  <Multiselect
                    options={industyPreferenceList.map((industry) => ({
                      name: industry,
                      id: industry,
                    }))}
                    selectedValues={data.projectIndustyPreferenceList}
                    displayValue="name"
                    placeholder="Select industry"
                    closeIcon="cancel"
                    onSelect={(selectedList, selectedItem) => {
                      setData({
                        ...data,
                        projectIndustyPreferenceList: selectedList,
                      });
                      console.log(data.projectIndustyPreferenceList);
                    }}
                    onRemove={(selectedList, removedItem) => {
                      setData({
                        ...data,
                        projectIndustyPreferenceList: selectedList,
                      });
                      console.log(data.projectIndustyPreferenceList);
                    }}
                    style={{
                      chips: {
                        background: "#365561",
                      },
                      searchBox: {
                        border: "none",
                        width: "100%",
                      },
                      multiselectContainer: {
                        width: "100%",
                      },
                      optionContainer: {
                        marginTop: "-21px",
                      },
                    }}
                  />
                </div>
              )}
          </div>
        </div>
        <div className="flex-center mb-1">
          <label className="fieldlabels">Daily Budget (max)</label>
          <input
            type="text"
            placeholder="Daily budget"
            onChange={(e) =>
              setData({ ...data, projectDailyBudget: e.target.value })
            }
            value={data.projectDailyBudget}
          />
        </div>
        <div className="flex-center mb-1">
          <label className="fieldlabels">Project Category</label>
          <select
            className="form-control"
            onChange={(e) =>
              setData({
                ...data,
                projectCategory: e.target.value,
                projectSuggestedSkills: [],
              })
            }
            value={data.projectCategory}
          >
            <option value="">Select category</option>
            {projCategory &&
              Object.keys(projCategory).map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
          </select>
        </div>
      </div>
      <input
        type="button"
        className="action-button"
        defaultValue="Next"
        onClick={() => {
          const regEx = /\S+@\S+\.\S+/;
          if (!regEx.test(data.leadEmail)) {
            setEmailClassName("border border-danger");
            setShowInvalidEmail(true);
            return;
          } else {
            setEmailClassName("");
            setShowInvalidEmail(false);
          }
          if (data.clientOwner === "") {
            setClientOwnerClassName("border border-danger");
            setInvalidClientOwner(true);
            setClientOwnerErrorMsg("Client Owner is required");
            return;
          } else {
            setInvalidClientOwner(false);
            setClientOwnerClassName("");
          }
          if (data.projectName === "") {
            setProjectNameClassName("border border-danger");
            setShowInvalidProjectName(true);
            setProjNameErrorMsg("Project name is required");
            return;
          } else {
            const regex = /[!@#$%^*()+=\[\]\\';,./{}|\\":<>?_]/g;
            if (regex.test(data.projectName)) {
              setShowInvalidProjectName(true);
              // setProjNameErrorMsg('Project name should not have special characters "( )" or "/ \".')
              setProjNameErrorMsg(
                "Project name should not have special characters [!@#$%^*()+=';,./{}|\":<>?_]"
              );
              setProjectNameClassName("border border-danger");
              return;
            }
            setProjectNameClassName("");
            setShowInvalidProjectName(false);
          }
          // if (data.projectDescription.length > 1800) {
          //   return;
          // }
          if (!profileTypeSelected) {
            setProfileTypeClassName("border border-danger");
            setShowInvalidProfileType(true);
            return;
          } else if (!profileTypeSelected) {
            setProfileTypeClassName("");
            setShowInvalidProfileType(false);
          }
          if (isLead && (data.company === "" || data.company.length === 0)) {
            setCompanyClassName("border border-danger");
            setShowInvalidCompany(true);
            setCompanyErrorMsg("Company is required");
            return;
          } else {
            setCompanyClassName("");
            setShowInvalidCompany(false);
          }
          if (data.projectRegion === "") {
            setData({ ...data, projectRegion: "Global" });
          }
          setActiveTab("profileDetails");
        }}
      />

      {/* {initializePopup && (
            <div className="linkedin-popup-wrapper">
                <div className="tab-pane fade show linkedin-div">
                    <center>
                        <p style={{fontSize: '18px'}}>Checking zoho...</p><br />
                        <img src={LoadingIcon} alt="" style={{ width: '50px', marginRight: '5px' }} />
                    </center>
                </div>
            </div>
        )} */}
    </fieldset>
  );
}
